import * as API from './api';
import * as actionTypes from './actiontypes';
import { startPageLoading, stopPageLoading } from '../page_details/actions';
import { log } from '../../config/utils';

export const updateSelectedDateRange = payload => {
  return {
    type: actionTypes.UPDATE_SELECTED_DATE_RANGE,
    payload,
  };
}

export const getChatHistory = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.HISTORY_LOADING
    });
    API.getChatHistory(payload, (error, response) => {
      log('getChatHistory', response);
      if (callback) callback(response);
      if (!error) {
        dispatch({
          type: actionTypes.HISTORY_RECEIVED,
          payload: response,
        });
      }
      else {
        dispatch({
          type: actionTypes.HISTORY_ERROR,
        });
      }
    });
  };
}

export const loadMoreHistory = payload => {
  return dispatch => {
    API.getChatHistory(payload, (error, response) => {
      log('loadMore getChatHistory', response);
      if (!error) {
        dispatch({
          type: actionTypes.MORE_HISTORY_RECEIVED,
          payload: response,
        });
      }
    });
  };
}

export const updateHistoryFilterSelection = payload => {
  return {
    type: actionTypes.UPDATE_HISTORY_FILTER,
    payload,
  };
}

export const removeHistoryFilterItem = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_HISTORY_FILTER_ITEM,
      payload
    });
    return Promise.resolve();
  }
}

export const clearHistoryFilter = () => {
  return {
    type: actionTypes.CLEAR_HISTORY_FILTER,
  };
}

export const clearCurrentHistoryChatItem = () => {
  return {
    type: actionTypes.CLEAR_CURRENT_HISTORY_CHAT_ITEM,
  };
}

export const setCurrentHistoryChatItem = payload => {
  return {
    type: actionTypes.SET_CURRENT_HISTORY_CHAT_ITEM,
    payload,
  };
}

export const getCurrentChatHistory = (payload, callback) => {
  return dispatch => {
    log('getCurrentChatHistory payload', payload);
    dispatch({
      type: actionTypes.GET_CURRENT_HISTORY_LOADING,
    });
    API.getCurrentChatHistory(payload, (error, response) => {
      log('getCurrentChatHistory response', response);
      if (!error) {
        dispatch({
          type: actionTypes.GET_CURRENT_HISTORY_RECEIVED,
          payload: response,
        });
        if (callback) callback();
      } else {
        dispatch({
          type: actionTypes.GET_CURRENT_HISTORY_FAILED,
          payload: response,
        });
      }
    });
  };
}

export const updateCustumAgentNoteFormInHistory = (payload, form, callback) => {
  return dispatch => {
    dispatch(startPageLoading("updating"));
    API.updateCustumAgentNoteForm(payload, (error, response) => {
      dispatch(stopPageLoading());
      if (!error && response) {
        if (callback) callback();
        dispatch({
          type: actionTypes.UPDATE_CUSTOM_AGENT_NOTE_FORM_IN_HISTORY,
          payload: form
        });
      }
    });
  };
}

export const updateReviewStatusInHistory = payload => {
  return dispatch => {
    dispatch(startPageLoading("updating"));
    API.updateReviewStatusInHistory(payload, (error, response) => {
      log('gupdateReviewStatus response', response);
      dispatch(stopPageLoading());
      if (!error && response && response.data && response.data.sessionId && response.data.reviewStatus) {
        dispatch({
          type: actionTypes.UPDATE_REVIEW_STATUS_IN_HISTORY,
          payload: response.data
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/data/redux/history_details/actions.js